import React from "react";

const STYLES = `
  .sxi_3f92d6a4_main_container,
  .sxi_3f92d6a4_main_container * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .sxi_3f92d6a4_main_container {
    --sxi_3f92d6a4_primary: #A31A13;
    --sxi_3f92d6a4_accent: #E3530F;
    /* navy + slate sampled from the source artwork; not defined in branding.json */
    --sxi_3f92d6a4_navy: #16305F;
    --sxi_3f92d6a4_slate: #333;
    --sxi_3f92d6a4_muted: #333333;
    --sxi_3f92d6a4_card_bg: #FAF7F4;
    --sxi_3f92d6a4_card_border: #F4E7DA;
    --sxi_3f92d6a4_radius_card: 16px;
    --sxi_3f92d6a4_radius_pill: 50px;
    --sxi_3f92d6a4_font: 'Mulish', sans-serif;
    --sxi_3f92d6a4_gap: clamp(1.5rem, 3vw, 2.5rem);
    --sxi_3f92d6a4_badge: clamp(92px, 10vw, 122px);

    position: relative;
    overflow: hidden;
    padding: clamp(3.5rem, 7vw, 5.5rem) 0 calc(clamp(3.5rem, 7vw, 5.5rem) + 10px);
    background: #FFFCFA;
    color: var(--sxi_3f92d6a4_slate);
    -webkit-font-smoothing: antialiased;
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_container {
    max-width: 74rem;
    margin-inline: auto;
    padding-inline: clamp(1.25rem, 4vw, 2rem);
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_header {
    max-width: 46rem;
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_title {
    font-size: 28px;
    font-weight: 900;
    line-height: 50px;
    letter-spacing: -0.01em;
    text-wrap: balance;
  }

  @media screen and (max-width: 767px) {
    .sxi_3f92d6a4_main_container .sxi_3f92d6a4_title {
      font-size: 25px;
      line-height: 35px;
    }
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_title_top {
    display: block;
    color: var(--sxi_3f92d6a4_navy);
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_title_brand {
    display: block;
    color: var(--sxi_3f92d6a4_accent);
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_divider {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    margin: 1.375rem 0 1.125rem;
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_line {
    width: 56px;
    height: 3px;
    border-radius: 999px;
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_line_accent { background: var(--sxi_3f92d6a4_accent); }
  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_line_navy { background: var(--sxi_3f92d6a4_navy); }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: var(--sxi_3f92d6a4_primary);
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_lead {
    font-size: clamp(1.0625rem, 0.95rem + 0.6vw, 1.25rem);
    color: var(--sxi_3f92d6a4_muted);
  }

  /* ---------- stat cards ---------- */

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_stats_grid {
    list-style: none;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: var(--sxi_3f92d6a4_gap);
    margin-top: clamp(2.5rem, 5vw, 3.75rem);
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_stat_card {
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    text-align: center;
    background: var(--sxi_3f92d6a4_card_bg);
    border: 1px solid var(--sxi_3f92d6a4_card_border);
    border-radius: var(--sxi_3f92d6a4_radius_card);
    padding-bottom: clamp(2rem, 3.5vw, 2.75rem);
    box-shadow: 0 18px 40px -18px rgba(163, 26, 19, 0.18), 0 4px 14px rgba(22, 48, 95, 0.05);
    transition: transform 0.25s ease, box-shadow 0.25s ease;
  }

  @media (hover: hover) {
    .sxi_3f92d6a4_main_container .sxi_3f92d6a4_stat_card:hover {
      transform: translateY(-5px);
      box-shadow: 0 26px 48px -18px rgba(163, 26, 19, 0.26), 0 6px 18px rgba(22, 48, 95, 0.07);
    }
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_media {
    position: relative;
    height: clamp(150px, 17vw, 190px);
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_wave {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    height: clamp(64px, 8vw, 84px);
    display: block;
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_badge {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    width: var(--sxi_3f92d6a4_badge);
    height: var(--sxi_3f92d6a4_badge);
    display: grid;
    place-items: center;
    color: var(--sxi_3f92d6a4_accent);
    background: #FFFFFF;
    border: 2px solid var(--sxi_3f92d6a4_accent);
    border-radius: 50%;
    box-shadow: 0 12px 24px -12px rgba(163, 26, 19, 0.4);
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_badge svg {
    width: 50%;
    height: 50%;
    display: block;
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_stat_body {
    padding-inline: clamp(1.25rem, 3vw, 2rem);
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_stat_value {
    display: block;
    color: var(--sxi_3f92d6a4_accent);
    font-size: clamp(2rem, 1.2rem + 2.4vw, 2.75rem);
    font-weight: 900;
    line-height: 1.15;
    letter-spacing: -0.01em;
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_stat_label {
    display: block;
    margin-top: 0.375rem;
    color: var(--sxi_3f92d6a4_primary);
    font-size: 1.3125rem;
    font-weight: 800;
    line-height: 1.3;
    text-wrap: balance;
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_stat_label::after {
    content: "";
    display: block;
    width: 44px;
    height: 3px;
    border-radius: 999px;
    background: var(--sxi_3f92d6a4_accent);
    margin: 1.25rem auto 0;
  }

  .sxi_3f92d6a4_main_container .sxi_3f92d6a4_stat_copy {
    color: var(--sxi_3f92d6a4_muted);
    margin-top: 1rem;
    font-size: 16px;
    line-height: 22px;
  }

  /* ---------- responsive ---------- */

  @media (max-width: 767.98px) {
    .sxi_3f92d6a4_main_container .sxi_3f92d6a4_stats_grid {
      grid-template-columns: 1fr;
      max-width: 30rem;
      margin-inline: auto;
      row-gap: 2rem;
    }

    .sxi_3f92d6a4_main_container .sxi_3f92d6a4_stat_label { font-size: 1.1875rem; }

    .sxi_3f92d6a4_main_container .sxi_3f92d6a4_stat_copy {
      font-size: 14px;
      line-height: normal;
    }
  }

  @media (max-width: 420px) {
    .sxi_3f92d6a4_main_container .sxi_3f92d6a4_stat_body { padding-inline: 1.25rem; }
  }

  @media (prefers-reduced-motion: reduce) {
    .sxi_3f92d6a4_main_container .sxi_3f92d6a4_stat_card { transition: none; }

    .sxi_3f92d6a4_main_container .sxi_3f92d6a4_stat_card:hover { transform: none; }
  }
`;

const Wave = ({ gradientId }) => (
  <svg
    className="sxi_3f92d6a4_wave"
    viewBox="0 0 800 160"
    preserveAspectRatio="none"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#F05A1E" />
        <stop offset="1" stopColor="#FBB040" />
      </linearGradient>
    </defs>
    <path
      d="M0,42 C170,-2 300,86 500,86 C650,86 710,36 800,48 L800,110 C710,98 650,148 500,148 C300,148 170,60 0,104 Z"
      fill={`url(#${gradientId})`}
    />
  </svg>
);

const BranchIcon = () => (
  <svg
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    focusable="false"
  >
    <path d="M24 43s13-11.6 13-20.3A13 13 0 1 0 11 22.7C11 31.4 24 43 24 43Z" />
    <circle cx="24" cy="22" r="4.6" />
  </svg>
);

const AtmIcon = () => (
  <svg
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    focusable="false"
  >
    <rect x="8" y="7" width="32" height="34" rx="3" />
    <rect x="12" y="12" width="14" height="11" rx="1.5" />
    <rect x="29.5" y="12" width="3.6" height="3.6" rx="0.9" />
    <rect x="34.8" y="12" width="3.6" height="3.6" rx="0.9" />
    <rect x="29.5" y="17.4" width="3.6" height="3.6" rx="0.9" />
    <rect x="34.8" y="17.4" width="3.6" height="3.6" rx="0.9" />
    <rect x="29.5" y="28" width="3.6" height="3.6" rx="0.9" />
    <rect x="34.8" y="28" width="3.6" height="3.6" rx="0.9" />
    <rect x="29.5" y="33.4" width="3.6" height="3.6" rx="0.9" />
    <rect x="34.8" y="33.4" width="3.6" height="3.6" rx="0.9" />
    <rect x="12" y="28" width="13" height="4.4" rx="1.2" />
    <path d="M12 37h9" />
  </svg>
);

const STATS = [
  {
    id: "sxi_3f92d6a4_wave_a",
    Icon: BranchIcon,
    value: "7,600+",
    label: "Branches",
    copy: "A widespread network across India",
  },
  {
    id: "sxi_3f92d6a4_wave_b",
    Icon: AtmIcon,
    value: "12,100+",
    label: "ATMs & Cash Recycling Machines",
    copy: "Easy access to your money, wherever you go",
  },
];

export default function BankYouCanTrust() {
  return (
    <section className="sxi_3f92d6a4_main_container" aria-labelledby="sxi_3f92d6a4_title">
      <style>{STYLES}</style>

      <div className="sxi_3f92d6a4_container">
        <div className="sxi_3f92d6a4_header">
          <h2 className="sxi_3f92d6a4_title" id="sxi_3f92d6a4_title">
            <span className="sxi_3f92d6a4_title_brand">
              A bank you can trust, <br /> wherever you go
            </span>
          </h2>
        </div>

        <ul className="sxi_3f92d6a4_stats_grid">
          {STATS.map(({ id, Icon, value, label, copy }) => (
            <li className="sxi_3f92d6a4_stat_card" key={id}>
              <div className="sxi_3f92d6a4_media">
                <Wave gradientId={id} />
                <span className="sxi_3f92d6a4_badge" aria-hidden="true">
                  <Icon />
                </span>
              </div>
              <div className="sxi_3f92d6a4_stat_body">
                <span className="sxi_3f92d6a4_stat_value">{value}</span>
                <span className="sxi_3f92d6a4_stat_label">{label}</span>
                <p className="sxi_3f92d6a4_stat_copy">{copy}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
